/**
 * To convert objects to url parameters
 * @param object
 * @returns {string}
 */
export const objectToStringParam = (
  object: Record<string, string | boolean | number | null | undefined>,
) => {
  const urlString = Object.entries(object)
    .filter(([, value]) => value !== null && value !== undefined)
    .map(
      ([key, value]: [string, any]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`,
    )
    .join('&')

  return urlString ? `?${urlString}` : ''
}
